import { LitElement, html, query, property } from 'lit-element'
import User from '@polleverywhere/core/lib/models/user'
import { normalizeXhrError } from '@polleverywhere/core/lib/util'
import { bemBlock } from '@polleverywhere/bem-helpers'
import { register } from '@polleverywhere/hmr-custom-element'
import { contextualize } from '@polleverywhere/cutlass'
import '@polleverywhere/pe-text-field'
import './style.scss'

function validate (textField) {
  textField.validate()
  if (!textField.valid) {
    textField.setAttribute('error', 'Presenter not found')
    return false
  }
  return true
}

function handleSubmit (e) {
  e.preventDefault()
  this.textField.setAttribute('error', '')

  if (validate(this.textField)) {
    joinPresentation.call(this, this.textField.value)
  }
}

function joinPresentation (username) {
  username = username.trim()
  User
    .check(username)
    .then((data) => {
      if (!data.exists) {
        this.textField.setAttribute('error', 'Presenter not found')
      }

      this.dispatchEvent(new CustomEvent('join', {
        bubbles: true,
        detail: {
          username,
          exists: !!data.exists
        }
      }))
    })
    .catch((xhr) => {
      const error = normalizeXhrError(xhr)
      this.textField.setAttribute('error', error.message)
    })
}

export default class Join extends LitElement {
  static get tagName () { return 'pollev-home-join' }

  @query('.pollev-home-join__input')
  textField

  @property({ type: Boolean })
  autofocus

  constructor () {
    super()

    // Example: Contextualize cutlass events as they bubble from this element.
    // https://github.com/polleverywhere/frontend/blob/master/packages/cutlass/README.md#contextualizing-events
    contextualize(this, this.tagName)
  }

  createRenderRoot () { return this }

  connectedCallback () {
    super.connectedCallback()

    if (this.autofocus) {
      this.updateComplete.then(() => this.querySelector(`.${bem('header')}`).focus())
    }
  }

  render () {
    return html`
      <form action='#' class=${bem('form')} method='POST' novalidate @submit=${e => handleSubmit.call(this, e)}>
        <h1 class=${bem('header')} tabindex='-1'>
          <label for='join-a-presentation'>Join presentation</label>
        </h1>
        <pe-text-field
          class=${bem('input')}
          id='join-a-presentation'
          aria-describedby='aria-join-username'
          type=text
          required
          pattern='[A-Za-z0-9]{3,}'
          placeholder='username'
          autocapitalize=off autocorrect=off spellcheck=false
          use-default-placeholder
        >
          <div slot='before' class=${bem('presenter-prefix')} role='presentation' @click=${() => this.textField.focus()}>PollEv.com/</div>
        </pe-text-field>
        <button class=${bem('submit')} type='submit'>Join</button>
        <div hidden id='aria-join-username'>Enter the presenter's username to join their presentation</div>
      </form>
    `
  }
}

const bem = bemBlock(Join.tagName)
register(module, Join.tagName, Join)
